var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_77_4262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.90002 3.73331H17.9V5.39997H2.90002V3.73331ZM2.90002 9.56664H17.9V11.2333H2.90002V9.56664ZM2.90002 15.4H17.9V17.0666H2.90002V15.4Z",
    fill: "#323130"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_77_4262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.400024 0.399994)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLine);
export default __webpack_public_path__ + "static/media/menu-line.a850bd9b0387a9edbd2a51080459a706.svg";
export { ForwardRef as ReactComponent };